var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"id":"powerBIcontainer","frameborder":"1","allowfullscreen":"","src":_vm.externalUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }